module.exports = __webpack_public_path__ + "img/ic_commonly_yellow.d2832502.svg";